module.exports = __webpack_public_path__ + "img/knowhow-3.aecaef2.webp";